import { CountReportEntity } from '../entities';
import { authResource } from './Auth';
export const AccountReportEncryptionCountResource = authResource({
    path: '/accounts/:accountId/reports/encryptions/count/:countId?',
    schema: CountReportEntity
}).extend('get', {
    process: (response) => ({ count: response })
});
